import React from 'react';
import { Clock, Plus } from 'lucide-react';
import { Section, Field, AutoText, AutoInput, MoveButtons, move, Segmented } from './OnsiteFields';
import { uid } from './useOnsitePlan';

const LEADS = [{ value: 'A', label: 'A' }, { value: 'B', label: 'B' }, { value: 'beide', label: 'beide' }];

function BlockRow({ b, i, total, upd, onMove, onRemove }) {
  return (
    <div className="border border-border/70 rounded-sm p-3 bg-secondary/10 flex gap-3" data-testid={`onsite-block-${i}`}>
      <div className="flex-1 min-w-0 space-y-2">
        <div className="flex flex-wrap items-center gap-2">
          <div className="flex items-center gap-1 text-xs">
            <Clock className="w-3 h-3 text-muted-foreground/60" />
            <input type="time" value={b.start || ''} onChange={(e) => upd({ start: e.target.value })} data-testid={`onsite-block-${i}-start`}
              className="bg-secondary/40 border border-border rounded-sm px-1.5 py-1 text-xs text-foreground w-[88px]" />
            <span className="text-muted-foreground/60">–</span>
            <input type="time" value={b.end || ''} onChange={(e) => upd({ end: e.target.value })} data-testid={`onsite-block-${i}-end`}
              className="bg-secondary/40 border border-border rounded-sm px-1.5 py-1 text-xs text-foreground w-[88px]" />
          </div>
          <AutoInput value={b.title} onChange={(v) => upd({ title: v })} placeholder="Programmpunkt (intern)" className="flex-1 min-w-[180px] font-medium" testId={`onsite-block-${i}-title`} />
          <Segmented value={b.lead} options={LEADS} onChange={(v) => upd({ lead: v })} />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          <Field label="Extern heißt das" hint="(so erscheint es in der Agenda für den Inhaber)"><AutoInput value={b.title_external} onChange={(v) => upd({ title_external: v })} testId={`onsite-block-${i}-ext`} /></Field>
          <Field label="Ziel des Blocks"><AutoInput value={b.goal} onChange={(v) => upd({ goal: v })} /></Field>
        </div>
        <Field label="Inhalt / Leitfragen (intern)"><AutoText value={b.content} onChange={(v) => upd({ content: v })} testId={`onsite-block-${i}-content`} /></Field>
      </div>
      <MoveButtons index={i} total={total} onMove={onMove} onRemove={onRemove} testId={`onsite-block-${i}-remove`} />
    </div>
  );
}

export function BlocksSection({ plan, setField }) {
  const blocks = plan.blocks || [];
  const save = (v) => setField('blocks', v, 'blocks');
  return (
    <Section id="os-blocks" icon={Clock} title="Ablauf" subtitle="interne Blöcke — Zeiten und externe Titel fließen in die Agenda" meta={plan.section_meta?.blocks} data={blocks} testId="onsite-blocks"
      right={<button onClick={() => save([...blocks, { id: uid(), start: '', end: '', title: '', title_external: '', content: '', lead: 'beide', goal: '' }])} data-testid="onsite-block-add"
        className="inline-flex items-center gap-1 text-[11px] text-teal-400 hover:text-teal-300 border border-teal-900/40 rounded-sm px-2 py-1"><Plus className="w-3 h-3" /> Block</button>}>
      <div className="space-y-3">
        {blocks.map((b, i) => (
          <BlockRow key={b.id || i} b={b} i={i} total={blocks.length}
            upd={(patch) => save(blocks.map((x, j) => (j === i ? { ...x, ...patch } : x)))}
            onMove={(f, t) => save(move(blocks, f, t))} onRemove={() => save(blocks.filter((_, j) => j !== i))} />
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 pt-2 border-t border-border/50">
        <Field label="Zeitpuffer"><AutoText value={plan.buffer_note} onChange={(v) => setField('buffer_note', v, 'blocks')} /></Field>
        <Field label="Tonalität intern → extern"><AutoText value={plan.tonality_note} onChange={(v) => setField('tonality_note', v, 'blocks')} /></Field>
      </div>
    </Section>
  );
}
